import { MS_PER_DAY } from './dates.js';
import { expandEvent } from './occurrences.js';
function matchedFields(event, needle) {
    const fields = [];
    if (event.title.toLowerCase().includes(needle))
        fields.push('title');
    if (event.location?.toLowerCase().includes(needle))
        fields.push('location');
    if (event.notes?.toLowerCase().includes(needle))
        fields.push('notes');
    return fields;
}
/**
 * Picks the occurrence a hit should show: the first one at/after `now`, otherwise the
 * last one before it. Non-recurring events always resolve to themselves.
 */
function representativeOccurrence(event, now, horizonMs) {
    const ahead = expandEvent(event, { from: now, to: now + horizonMs, limitPerEvent: 1 });
    const next = ahead[0];
    if (next)
        return { occurrence: next, upcoming: true };
    const behind = expandEvent(event, { from: now - horizonMs, to: now, limitPerEvent: 400 });
    const previous = behind[behind.length - 1];
    if (previous)
        return { occurrence: previous, upcoming: false };
    return null;
}
export function searchEvents(events, query, options = {}) {
    const needle = query.trim().toLowerCase();
    const now = options.now ?? Date.now();
    const horizonMs = (options.horizonDays ?? 730) * MS_PER_DAY;
    const limit = options.limit ?? 50;
    if (needle.length === 0)
        return { query: '', upcoming: [], past: [], total: 0 };
    const upcoming = [];
    const past = [];
    for (const event of events) {
        if (options.memberId && !event.ownerIds.includes(options.memberId))
            continue;
        const matchedIn = matchedFields(event, needle);
        if (matchedIn.length === 0)
            continue;
        const resolved = representativeOccurrence(event, now, horizonMs);
        if (!resolved)
            continue;
        const hit = {
            event,
            occurrence: resolved.occurrence,
            matchedIn,
            upcoming: resolved.upcoming,
        };
        (resolved.upcoming ? upcoming : past).push(hit);
    }
    // Coming up first and soonest-first; past results newest-first (design Screen C · 8).
    upcoming.sort((a, b) => Date.parse(a.occurrence.start) - Date.parse(b.occurrence.start));
    past.sort((a, b) => Date.parse(b.occurrence.start) - Date.parse(a.occurrence.start));
    return {
        query: needle,
        upcoming: upcoming.slice(0, limit),
        past: past.slice(0, limit),
        total: upcoming.length + past.length,
    };
}
//# sourceMappingURL=search.js.map